import { useContext, useEffect } from 'react';
import AuthContext from '../stores/AuthContext';

/**
 * Marks the calling page as public (no account needed) while it is mounted.
 * If the session ends while a public page is showing, AuthProvider signs the
 * visitor out quietly instead of raising the "Logged out due to inactivity"
 * overlay, which forces a trip to /login. Without an AuthProvider (isolated
 * tests) it does nothing.
 */
export default function usePublicPage() {
  const context = useContext(AuthContext);
  const register = context && context.registerPublicPage;
  useEffect(() => {
    if (typeof register !== 'function') return undefined;
    return register();
  }, [register]);
}
